/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Status_ColInputs */

const en_admin_categories_status_col = /** @type {(inputs: Admin_Categories_Status_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const zh_admin_categories_status_col = /** @type {(inputs: Admin_Categories_Status_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Admin_Categories_Status_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_status_col = /** @type {((inputs?: Admin_Categories_Status_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Status_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_status_col(inputs)
	return zh_admin_categories_status_col(inputs)
});
export { admin_categories_status_col as "admin.categories.status_col" }